export const config = {
  title: "Jeff LeBlanc Keller Williams First Choice | Prairieville, LA",
  meta: {
    description:
      "Jeff LeBlanc, a dedicated real estate expert with Keller Williams First Choice, helps clients buy and sell homes in Prairieville, LA and surrounding areas.",
    keywords: [
      "Jeff LeBlanc realtor",
      "Keller Williams Prairieville",
      "homes for sale Prairieville LA",
      "real estate agent Louisiana",
      "buying selling homes Prairieville"
    ],
    author: "Jeff LeBlanc Keller Williams First Choice",
    canonicalUrl: "https://www.homesbyjeffleblanc.com/",
  },
  sections: {
    header: {
      businessName: "Jeff LeBlanc Keller Williams First Choice",
    },
    sectionB: {
      heroTitle: "Find Your Dream Home",
      heroSubtitle: "Guiding you through every step of your real estate journey in Prairieville, LA",
      learnAboutText: "View Listings",
      phoneNumber: "2252530963",
      phoneLabel: "(225) 253-0963",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2163132165/photo/houses-align-a-residential-district-next-to-road.jpg?s=612x612&w=0&k=20&c=JwTatZ7qyrv0s0UZa6yZ_WpByb_0M7GN9ZXZQOrWWRk=",
      cardData: [
        {
          title: "Home Buying",
          description: "Get expert guidance to find the perfect home in Prairieville and beyond.",
        },
        {
          title: "Home Selling",
          description: "Sell your property quickly and for top value with our proven strategies.",
        },
        {
          title: "Market Insights",
          description: "Stay ahead with the latest real estate trends and neighborhood data.",
        },
      ],
      description:
        "Whether you're buying or selling, Jeff LeBlanc with Keller Williams First Choice brings expertise, dedication, and local knowledge to help you succeed.",
    },
    sectionC: {
      servicesTitle: "Real Estate Services",
      servicesDescription:
        "Helping clients navigate the real estate market with ease and confidence.",
      cards: [
        {
          title: "Home Buying",
          description: "Personalized home search and negotiation strategy.",
          imageSrc: "https://media.istockphoto.com/id/1567383839/photo/real-estate-concept-business-home-insurance-and-real-estate-protection-buy-and-sell-houses.jpg?s=612x612&w=0&k=20&c=jrBOzY275KW_ahIWkv-ZRC_TVNpAkPPHaztdCBhrk18=",
          imageAlt: "Home Buying",
        },
        {
          title: "Home Selling",
          description: "Professional listings, open house support, and more.",
          imageSrc: "https://media.istockphoto.com/id/2197655235/photo/close-up-of-three-people-looking-at-financial-data-with-graphs-and-charts.jpg?s=612x612&w=0&k=20&c=rOX0dS9sbA5EaYkcj-UdjeboXoopcu4-dy6qp0XJy_c=",
          imageAlt: "Home Selling",
        },
        {
          title: "Market Analysis",
          description: "Understand your home's market value and position.",
          imageSrc: "https://media.istockphoto.com/id/2155527498/photo/asian-businesswoman-discusses-home-purchase-contracts-with-clients-at-her-desk-focusing-on.jpg?s=612x612&w=0&k=20&c=vSLUrcEeGPlL_P0BFxzMK03Cfcuiaz4Z2R17whH4auI=",
          imageAlt: "Market Analysis",
        },
      ],
      otherServicesTitle: "Why Choose Jeff LeBlanc",
      otherServicesList: [
        "Local Market Expertise",
        "Personalized Service",
        "Trusted Keller Williams Agent",
        "Smooth Closings",
        "Client-First Approach",
      ],
    },
    sectionD: {
      aboutTitle: "About Jeff LeBlanc",
      aboutImage: {
        src: "https://media.istockphoto.com/id/2163132165/photo/houses-align-a-residential-district-next-to-road.jpg?s=612x612&w=0&k=20&c=JwTatZ7qyrv0s0UZa6yZ_WpByb_0M7GN9ZXZQOrWWRk=",
        alt: "Jeff LeBlanc",
      },
      aboutText: [
        "Jeff LeBlanc is a top-performing real estate agent with Keller Williams First Choice, serving Prairieville, Baton Rouge, and surrounding areas.",
        "With a client-first philosophy, Jeff delivers seamless transactions and exceptional results.",
      ],
    },
    sectionE: {
      profileImage: "https://images.marketleader.com/Logos/03/921903_normal.png",
      profileAlt: "Jeff LeBlanc Profile Photo",
      businessName: "Jeff LeBlanc Keller Williams First Choice",
      contact: {
        phone: "2252530963",
        phoneLabel: "(225) 253-0963",
        email: "jeff.leblanc@kw.com",
        website: "https://www.homesbyjeffleblanc.com/",
        address: "17111 Commerce Center, Suite A & B, Prairieville, LA 70769, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "17111 Commerce Center, Suite A & B, Prairieville, LA 70769, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11029.558109228993!2d-91.0438514!3d30.3062948!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8626e4686b3e2a97%3A0xf3ab4f4747d3a34a!2s17111%20Commerce%20Centre%20Dr%2C%20Prairieville%2C%20LA%2070769%2C%20USA!5e0!3m2!1sen!2sus!4v1695011220941",
    },    
  },
};

export default config;
